var M = Object.defineProperty, U = Object.defineProperties;
var G = Object.getOwnPropertyDescriptors;
var P = Object.getOwnPropertySymbols;
var q = Object.prototype.hasOwnProperty, W = Object.prototype.propertyIsEnumerable;
var I = (e, t, i) => t in e ? M(e, t, { enumerable: !0, configurable: !0, writable: !0, value: i }) : e[t] = i, c = (e, t) => {
  for (var i in t || (t = {}))
    q.call(t, i) && I(e, i, t[i]);
  if (P)
    for (var i of P(t))
      W.call(t, i) && I(e, i, t[i]);
  return e;
}, D = (e, t) => U(e, G(t));
var _ = (e, t, i) => new Promise((d, o) => {
  var n = (a) => {
    try {
      r(i.next(a));
    } catch (g) {
      o(g);
    }
  }, f = (a) => {
    try {
      r(i.throw(a));
    } catch (g) {
      o(g);
    }
  }, r = (a) => a.done ? d(a.value) : Promise.resolve(a.value).then(n, f);
  r((i = i.apply(e, t)).next());
});
import { $emit as l } from "../utils/gogocodeTransfer.js";
import { g as z } from "../get-2ba9bcdb.js";
import B from "js-cookie";
import { M as H } from "../md5-12db3a3a.js";
import { ElForm as j, ElFormItem as K } from "element-plus";
import Y from "../step-dialog/index.js";
import Z from "../step-dialog-item/index.js";
import J from "../input/index.js";
import { resolveComponent as C, resolveDirective as Q, openBlock as p, createBlock as b, withCtx as u, renderSlot as X, createVNode as S, withModifiers as $, withKeys as ee, createElementVNode as m, toDisplayString as h, createTextVNode as y, withDirectives as O, createElementBlock as R, normalizeClass as A, createCommentVNode as v } from "vue";
import { _ as te } from "../_plugin-vue_export-helper-dad06003.js";
import "../_commonjsHelpers-ce4d82cc.js";
import "../isSymbol-62c14278.js";
import "../util-b2b0dc25.js";
const L = /* @__PURE__ */ new Map([
  ["cn", "zh_CN"],
  ["jp", "ja_JP"],
  ["kr", "ko_KR"],
  ["vn", "vi_VN"],
  ["ru", "ru_RU"],
  ["cn_tw", "zh_TW"],
  ["tr", "tr_TR"]
]), V = {
  // 手机绑定
  PHONE_BIND: "PHONE_BIND",
  // 手机换绑
  PHONE_REPLACE: "PHONE_REPLACE",
  // 邮箱绑定
  EMAIL_BIND: "EMAIL_BIND",
  // 邮箱换绑
  EMAIL_REPLACE: "EMAIL_REPLACE",
  // 谷歌绑定
  GOOGLE_BIND: "GOOGLE_BIND",
  // 谷歌换绑
  GOOGLE_REPLACE: "GOOGLE_REPLACE",
  // 修改密码 mfa-v2
  PASSWORD_MODIFY: "PASSWORD_MODIFY",
  // 找回密码 mfa-v3
  PASSWORD_FORGET: "PASSWORD_FORGET",
  // 添加美元银行账户验证规则mfa-v2
  "/asset/bank/login": "/asset/bank/login",
  // 美元ACH充值验证规则mfa-v2
  "/asset/fiat/bank/deposit": "/asset/fiat/bank/deposit",
  // 美元ACH提现验证规则mfa-v2 & 美元Wire提现验证规则 mfa-v2
  "/asset/fiat/withdraw": "/asset/fiat/withdraw",
  // API 管理
  "/user-center/user-api": "/user-center/user-api",
  "/user-center/user-api-create": "/user-center/user-api-create",
  "/user-center/user-api-update": "/user-center/user-api-update",
  "/gateway-auth/user-api": "/gateway-auth/user-api",
  "/gateway-auth/user-api-create": "/gateway-auth/user-api-create",
  "/gateway-auth/user-api-update": "/gateway-auth/user-api-update",
  // 新建和修改提币地址
  "/create/coinWithdrawlAddr": "/asset/account/create/coinWithdrawlAddr",
  // 虚拟币提现
  "/virtualCoin/withdraw-v2": "/asset/account/virtualCoin/withdrawl-v2",
  // 用户新增或修改防钓鱼码
  "/anti-fishing-code/update": "/user-center/anti-fishing-code/update",
  // 链端提现
  "/asset/virtual/withdraw": "/asset/virtual/withdraw",
  // 内部提现
  "/virtualCoin/internal-withdraw": "/asset/virtual/initInternalWithdraw",
  // 以下是登陆相关
  LOGIN: "LOGIN",
  AUTH_DEVICE: "AUTH_DEVICE",
  // 子账户mfa
  SUB_USER_OPERATION: "SUB_USER_OPERATION",
  SAVE_WITHDRAWAL_ADDRESS: "SAVE_WITHDRAWAL_ADDRESS"
}, ie = (e, t, i) => {
  const o = Object.keys(e).sort().reduce((f, r) => {
    const a = e[r];
    return r !== "timestamp" && a !== null && a !== void 0 && a !== "" ? f.concat(`${r}=${a}`) : f;
  }, []), n = H(o.join("&") + `${t}${i}`).toString();
  return Object.assign(e, {
    sign: n
  }), n;
}, oe = (e) => L.has(e) ? L.get(e) : "en_US", k = Object.values(V), F = 60, N = {
  needEmailCode: {
    label: "bmui-verify-flow.Email_Code",
    name: "emailCode"
  },
  needPhoneCode: {
    label: "bmui-verify-flow.Sms_Code",
    name: "phoneCode"
  },
  needTotpCode: {
    label: "bmui-verify-flow.Google_Code",
    name: "totpCode"
  }
}, ne = ["needEmailCode", "needPhoneCode", "needTotpCode"], ae = {
  name: "rMfaStepDialog",
  components: { Form: j, FormItem: K, Input: J, StepDialog: Y, StepDialogItem: Z },
  props: {
    /**
     * 开始
     */
    start: {
      type: Boolean,
      default: !1
    },
    /**
     * 验证类型
     */
    operationBizType: {
      validator: (e) => k.includes(e),
      default: k[0]
    },
    /**
     * 接收邮件的邮箱
     */
    email: {
      type: String,
      default: ""
    },
    /**
     * 接收短信的手机号
     */
    phone: {
      type: String,
      default: ""
    },
    /**
     * 开启短信验证码
     */
    needPhoneCode: {
      type: Boolean,
      default: !1
    },
    /**
     * 开启邮箱验证码
     */
    needEmailCode: {
      type: Boolean,
      default: !1
    },
    /**
     * 开启谷歌验证码
     */
    needTotpCode: {
      type: Boolean,
      default: !1
    },
    /**
     * 是否必须登录
     */
    loginRequired: {
      type: Boolean,
      default: !0
    },
    /**
     * loginRequired 为 false 时必须提供
     */
    scyToken: {
      type: String,
      default: ""
    },
    /**
     * axios实例, 组件本身没法发请求，只能使用者传咯
     */
    axiosClient: {
      type: Function,
      dafault: null
    },
    /**
     * 登录名，必须要
     */
    loginName: {
      type: String,
      default: ""
    },
    /**
     * 语言, 必须要
     */
    locale: {
      type: String,
      default: "cn"
    },
    /**
     * 获取用户信息
     */
    getUserSecInfo: {
      type: Promise,
      default: null
    },
    /**
     * 上一步按钮loading
     */
    prevBtnLoading: {
      type: Boolean,
      default: !1
    },
    /**
     * 下一步按钮loading
     */
    nextBtnLoading: {
      type: Boolean,
      default: !1
    },
    /**
     * 上一步按钮禁用
     */
    prevBtnDisabled: {
      type: Boolean,
      default: !1
    },
    /**
     * 下一步按钮禁用
     */
    nextBtnDisabled: {
      type: Boolean,
      default: !1
    }
  },
  watch: {
    start: function(e, t) {
      !e && t && this.initMfaForm();
    },
    "codeSendTimer.emailCode": function(e) {
      if (e > 0) {
        const t = e - 1;
        this.codeSendTimer.email = setTimeout(() => {
          this.codeSendTimer.emailCode = t;
        }, 1e3);
      }
    },
    "codeSendTimer.phoneCode": function(e) {
      if (e > 0) {
        const t = e - 1;
        this.codeSendTimer.phone = setTimeout(() => {
          this.codeSendTimer.phoneCode = t;
        }, 1e3);
      }
    }
  },
  computed: {
    stepDialogItems() {
      return (this.$slots.default && this.$slots.default()).filter((e) => {
        var t;
        return (t = e.tag) == null ? void 0 : t.endsWith("rStepDialogItem");
      });
    },
    customFinnalStep() {
      return this.stepDialogItems.length - 1;
    },
    local() {
      return oe(this.locale);
    },
    sharedParams() {
      const e = {
        local: this.local,
        operationBizType: this.operationBizType
      };
      return this.loginRequired || Object.assign(e, {
        scyToken: this.scyToken
      }), e;
    },
    rules() {
      const e = {};
      return ne.forEach((t) => {
        this[t] && (e[N[t].name] = [
          {
            required: !0,
            trigger: "change",
            message: this.$t("bmui-verify-flow.required", [
              this.$t(N[t].label)
            ])
          }
        ]);
      }), e;
    },
    google2FaHelperLink() {
      return this.local.startsWith("zh_") ? "/html/user_zendesk_sso?redirect=/hc/zh-cn/articles/360001861413" : "/html/user_zendesk_sso?redirect=/hc/en-us/articles/360001861413-Issues-Regarding-Google-2FA";
    },
    sendEmailApi() {
      return this.loginRequired ? "/gw-api/user-center/send-email" : "/gw-api/user-center/send-email-with-scy";
    },
    sendSmsApi() {
      return this.loginRequired ? "/gw-api/user-center/send-sms" : "/gw-api/user-center/send-sms-with-scy";
    },
    mfaApi() {
      return this.loginRequired ? "/gw-api/user-center/validate/mfa-v2" : "/gw-api/user-center/validate/mfa-v3";
    },
    google2FaLabel() {
      return this.operationBizType === V.GOOGLE_REPLACE ? this.$t("bmui-verify-flow.Cur_Google_Code") : this.$t("bmui-verify-flow.Google_Code");
    }
  },
  data() {
    return {
      getUserInfoPending: !1,
      mfaCodes: {
        emailCode: "",
        phoneCode: "",
        totpCode: ""
      },
      // 验证码发送倒计时
      codeSendTimer: {
        emailCode: 0,
        phoneCode: 0
      },
      // 异步校验
      fieldsValidateStatus: {
        emailCode: null,
        phoneCode: null,
        totpCode: null
      },
      // pending 状态
      pendingStatus: {
        emailCodePending: !1,
        smsCodePending: !1,
        submitPending: !1
      }
    };
  },
  mounted() {
    !this.loginName && this.loginRequired && (this.getUserInfoPending = !0, this.getUserSecInfo && this.getUserSecInfo.finally(() => {
      this.getUserInfoPending = !1;
    }));
  },
  methods: {
    next(e, t) {
      l(this, "onNext", e, t);
    },
    prev(e, t) {
      l(this, "onPrev", e, t);
    },
    cancel() {
      l(this, "onCancel");
    },
    beforeClose(e) {
      l(this, "beforeClose", e);
    },
    onComfirm() {
      this.handleSubmit(this.mfaCodes);
    },
    didChange(e) {
      e.name === "mfa" && this.initMfaForm(), l(this, "didChange", e);
    },
    willChange(e) {
      l(this, "willChange", e);
    },
    initMfaForm() {
      this.mfaCodes = {
        emailCode: "",
        phoneCode: "",
        totpCode: ""
      }, this.codeSendTimer.email && clearTimeout(this.codeSendTimer.email), this.codeSendTimer.phone && clearTimeout(this.codeSendTimer.phone), this.codeSendTimer = {
        emailCode: 0,
        phoneCode: 0
      }, this.$nextTick().then(() => {
        var e;
        (e = this.$refs.mfaForm) == null || e.resetFields();
      });
    },
    getRequestBody(e = {}) {
      const t = B.get("accessToken"), i = B.get("accessSalt");
      if (this.loginRequired) {
        const d = D(c(c({}, this.sharedParams), e), {
          timestamp: (/* @__PURE__ */ new Date()).getTime()
        });
        return ie(d, d.timestamp, i), {
          data: d,
          headers: {
            Authorization: t
          }
        };
      } else
        return {
          data: c(c({}, this.sharedParams), e)
        };
    },
    handleSendEmail() {
      return _(this, null, function* () {
        const e = this.getRequestBody();
        if (this.pendingStatus.emailCodePending = !0, this.axiosClient)
          try {
            (yield this.axiosClient(c({
              method: "POST",
              url: this.sendEmailApi
            }, e))).success && (this.codeSendTimer.emailCode = F);
          } catch (t) {
          } finally {
            this.pendingStatus.emailCodePending = !1;
          }
      });
    },
    handleSendSms() {
      return _(this, null, function* () {
        const e = this.getRequestBody();
        if (this.pendingStatus.smsCodePending = !0, this.axiosClient)
          try {
            (yield this.axiosClient(c({
              method: "POST",
              url: this.sendSmsApi
            }, e))).success && (this.codeSendTimer.phoneCode = F);
          } catch (t) {
          } finally {
            this.pendingStatus.smsCodePending = !1;
          }
      });
    },
    handleSubmit(e) {
      return _(this, null, function* () {
        if (!this.pendingStatus.submitPending) {
          l(this, "startMfa");
          try {
            if (yield this.$refs.mfaForm.validate()) {
              l(this, "mfaValidate");
              const i = this.getRequestBody(e);
              if (this.pendingStatus.submitPending = !0, this.axiosClient) {
                const d = yield this.axiosClient(c({
                  method: "POST",
                  url: this.mfaApi
                }, i));
                if (d.success) {
                  const o = z(d, ["data", "mfaToken"]);
                  l(this, "pass", o);
                } else
                  l(this, "mfaError");
                this.pendingStatus.submitPending = !1;
              }
            }
          } catch (t) {
            this.pendingStatus.submitPending = !1, l(this, "mfaError");
          }
        }
      });
    }
  },
  emits: {
    /**
     * mfa开始
     */
    startMfa: null,
    /**
     * mfa校验通过
     */
    mfaValidate: null,
    /**
     * mfa失败
     */
    mfaError: null,
    /**
     * mfa校验通过，回传mfaToken
     */
    pass: (e) => e,
    /**
     * 点击右上角关闭回调，step为当前步
     */
    beforeClose: (e) => e,
    /**
     * 点击首页取消按钮
     */
    onCancel: null,
    /**
     * 点击上一步按钮，step为当前步，执行toPrev到上一步
     */
    onPrev: (e, t) => e,
    /**
     * 点击下一步按钮，step为当前步，执行toNext到下一步
     */
    onNext: (e, t) => e,
    /**
     * 即将改变步骤，step为当前步，onPrev和onNext时均会触发
     */
    willChange: (e) => e,
    /**
     * 步骤改变之后，step为最新步
     */
    didChange: (e) => e
  }
}, se = { class: "r-mfa-info-wrapper" }, re = { class: "r-mfa-info-label" }, le = { class: "r-mfa-info" }, de = ["disabled"], me = { class: "r-mfa-info-wrapper" }, ue = { class: "r-mfa-info-label" }, fe = { class: "r-mfa-info" }, ce = ["disabled"], he = { class: "r-mfa-info-wrapper" }, pe = { class: "r-mfa-info-label" }, ge = { class: "r-mfa-info r-mfa-info--2fa" }, Ce = ["href"];
function Se(e, t, i, d, o, n) {
  const f = C("Input"), r = C("FormItem"), a = C("Form"), g = C("StepDialogItem"), x = C("StepDialog"), T = Q("loading");
  return p(), b(x, {
    class: "r-mfa-step-dialog",
    onDidChange: n.didChange,
    onOnNext: n.next,
    onOnPrev: n.prev,
    onOnCancel: n.cancel,
    onBeforeClose: n.beforeClose,
    onOnComfirm: n.onComfirm,
    prevBtnLoading: i.prevBtnLoading,
    nextBtnLoading: i.nextBtnLoading,
    prevBtnDisabled: i.prevBtnDisabled,
    nextBtnDisabled: i.nextBtnDisabled,
    start: i.start
  }, {
    default: u(() => [
      X(e.$slots, "default"),
      S(g, {
        title: e.$t("bmui-verify-flow.title"),
        name: "mfa",
        class: "r-mfa-dialog-item"
      }, {
        default: u(() => [
          S(a, {
            model: o.mfaCodes,
            rules: n.rules,
            ref: "mfaForm",
            class: "r-mfa-content",
            loading: o.getUserInfoPending,
            "hide-required-asterisk": !0,
            onSubmit: t[5] || (t[5] = $(() => {
            }, ["prevent"])),
            onKeyup: t[6] || (t[6] = ee((s) => n.handleSubmit(o.mfaCodes), ["enter"])),
            "label-position": "top"
          }, {
            default: u(() => [
              i.needEmailCode ? (p(), b(r, {
                key: 0,
                prop: "emailCode",
                class: "r-mfa-group",
                label: e.$t("bmui-verify-flow.Email_Code"),
                error: o.fieldsValidateStatus.emailCode
              }, {
                label: u(({ label: s }) => [
                  m("div", se, [
                    m(
                      "div",
                      re,
                      h(s),
                      1
                      /* TEXT */
                    ),
                    m("div", le, [
                      y(
                        h(i.email) + " ",
                        1
                        /* TEXT */
                      ),
                      O((p(), R("button", {
                        type: "button",
                        class: A(["r-mfa-trigger", {
                          "r-mfa-trigger--pending": o.codeSendTimer.emailCode > 0
                        }]),
                        onClick: t[0] || (t[0] = (...E) => n.handleSendEmail && n.handleSendEmail(...E)),
                        disabled: o.codeSendTimer.emailCode > 0
                      }, [
                        y(
                          h(o.codeSendTimer.emailCode === 0 ? e.$t("bmui-verify-flow.Send_Code") : e.$t("bmui-verify-flow.countSec", [
                            o.codeSendTimer.emailCode
                          ])),
                          1
                          /* TEXT */
                        )
                      ], 10, de)), [
                        [
                          T,
                          o.pendingStatus.emailCodePending,
                          void 0,
                          { lock: !0 }
                        ]
                      ])
                    ])
                  ])
                ]),
                default: u(() => [
                  S(f, {
                    modelValue: o.mfaCodes.emailCode,
                    "onUpdate:modelValue": t[1] || (t[1] = (s) => o.mfaCodes.emailCode = s),
                    placeholder: e.$t("bmui-verify-flow.Email_Code_Placeholder")
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
                /* STABLE */
              }, 8, ["label", "error"])) : v("v-if", !0),
              i.needPhoneCode ? (p(), b(r, {
                key: 1,
                prop: "phoneCode",
                class: "r-mfa-group",
                label: e.$t("bmui-verify-flow.Sms_Code"),
                error: o.fieldsValidateStatus.phoneCode
              }, {
                label: u(({ label: s }) => [
                  m("div", me, [
                    m(
                      "div",
                      ue,
                      h(s),
                      1
                      /* TEXT */
                    ),
                    m("div", fe, [
                      y(
                        h(i.phone) + " ",
                        1
                        /* TEXT */
                      ),
                      O((p(), R("button", {
                        type: "button",
                        class: A(["r-mfa-trigger", {
                          "r-mfa-trigger--pending": o.codeSendTimer.emailCode > 0
                        }]),
                        onClick: t[2] || (t[2] = (...E) => n.handleSendSms && n.handleSendSms(...E)),
                        disabled: o.codeSendTimer.phoneCode > 0
                      }, [
                        y(
                          h(o.codeSendTimer.phoneCode === 0 ? e.$t("bmui-verify-flow.Send_Code") : e.$t("bmui-verify-flow.countSec", [
                            o.codeSendTimer.phoneCode
                          ])),
                          1
                          /* TEXT */
                        )
                      ], 10, ce)), [
                        [
                          T,
                          o.pendingStatus.smsCodePending,
                          void 0,
                          { lock: !0 }
                        ]
                      ])
                    ])
                  ])
                ]),
                default: u(() => [
                  S(f, {
                    modelValue: o.mfaCodes.phoneCode,
                    "onUpdate:modelValue": t[3] || (t[3] = (s) => o.mfaCodes.phoneCode = s),
                    placeholder: e.$t("bmui-verify-flow.Sms_Code_Placeholder"),
                    autocomplete: "nope"
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
                /* STABLE */
              }, 8, ["label", "error"])) : v("v-if", !0),
              i.needTotpCode ? (p(), b(r, {
                key: 2,
                prop: "totpCode",
                class: "r-mfa-group",
                label: n.google2FaLabel,
                error: o.fieldsValidateStatus.totpCode
              }, {
                label: u(({ label: s }) => [
                  m("div", he, [
                    m(
                      "div",
                      pe,
                      h(s),
                      1
                      /* TEXT */
                    ),
                    m("div", ge, [
                      m("a", {
                        href: n.google2FaHelperLink,
                        target: "_blank"
                      }, h(e.$t("bmui-verify-flow.missing_2fa_helper")), 9, Ce)
                    ])
                  ])
                ]),
                default: u(() => [
                  S(f, {
                    modelValue: o.mfaCodes.totpCode,
                    "onUpdate:modelValue": t[4] || (t[4] = (s) => o.mfaCodes.totpCode = s),
                    placeholder: n.google2FaLabel,
                    autocomplete: "nope"
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
                /* STABLE */
              }, 8, ["label", "error"])) : v("v-if", !0)
            ]),
            _: 1
            /* STABLE */
          }, 8, ["model", "rules", "loading"])
        ]),
        _: 1
        /* STABLE */
      }, 8, ["title"])
    ]),
    _: 3
    /* FORWARDED */
  }, 8, ["onDidChange", "onOnNext", "onOnPrev", "onOnCancel", "onBeforeClose", "onOnComfirm", "prevBtnLoading", "nextBtnLoading", "prevBtnDisabled", "nextBtnDisabled", "start"]);
}
const w = /* @__PURE__ */ te(ae, [["render", Se], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/mfa-step-dialog/mfa-step-dialog.vue"]]);
w.install = function(e) {
  e.component(w.name, w);
};
export {
  w as default
};
